
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index6Wwk9a0bBoj1qLLzk8J77xh3RnPhndkLGdOIIjgoWO4Meta } from "/tmp/tmpmgt48ojh/pages/index.vue?macro=true";
import { default as indexDy9IVlp0exXWhPSB4nR7eIRl296tD0g931zMfeaXqu4Meta } from "/tmp/tmpmgt48ojh/pages/[area]/index.vue?macro=true";
import { default as indexu1yyKmjq3YBJYEw7zb_y9UNVyqpSDfs_yOS_45dPGgFWMMeta } from "/tmp/tmpmgt48ojh/pages/okinawa/index.vue?macro=true";
import { default as indexrW192YjE_45S25NRDNT8jEGvHcNJSQZZUk3yT6xZlMeo8Meta } from "/tmp/tmpmgt48ojh/pages/ranking/index.vue?macro=true";
import { default as indexraIF5abbfQBfS4D8o8hmA9QzG0VCgUzb6pQYjL_IZioMeta } from "/tmp/tmpmgt48ojh/pages/okinawa/[id]/index.vue?macro=true";
import { default as indexAuJ_4503sopSsY20ZMwMQgTs8jFAcZhQ3TBTikpNFkUToMeta } from "/tmp/tmpmgt48ojh/pages/[area]/[pref]/index.vue?macro=true";
import { default as indexNMDQi1Nta_45FSS_45ybjddH_A4kSgt57PxNg9ZSbouSLUAMeta } from "/tmp/tmpmgt48ojh/pages/ranking/[area]/index.vue?macro=true";
import { default as indexPWrmrsAMVdKi2141nix2pt_eqErAcZmTicZiO_vPUzsMeta } from "/tmp/tmpmgt48ojh/pages/[area]/[pref]/[id]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmpmgt48ojh/pages/index.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/tmp/tmpmgt48ojh/pages/[area]/index.vue")
  },
  {
    name: "okinawa",
    path: "/okinawa",
    component: () => import("/tmp/tmpmgt48ojh/pages/okinawa/index.vue")
  },
  {
    name: "ranking",
    path: "/ranking",
    component: () => import("/tmp/tmpmgt48ojh/pages/ranking/index.vue")
  },
  {
    name: "okinawa-id",
    path: "/okinawa/:id()",
    component: () => import("/tmp/tmpmgt48ojh/pages/okinawa/[id]/index.vue")
  },
  {
    name: "area-pref",
    path: "/:area()/:pref()",
    component: () => import("/tmp/tmpmgt48ojh/pages/[area]/[pref]/index.vue")
  },
  {
    name: "ranking-area",
    path: "/ranking/:area()",
    component: () => import("/tmp/tmpmgt48ojh/pages/ranking/[area]/index.vue")
  },
  {
    name: "area-pref-id",
    path: "/:area()/:pref()/:id()",
    component: () => import("/tmp/tmpmgt48ojh/pages/[area]/[pref]/[id]/index.vue")
  }
]